/**
 * Like `setInterval`, but skips invoking `fn` while the tab is hidden. There's no
 * point polling an API or ticking a countdown for a page nobody can see, and it
 * wastes battery/network on backgrounded tabs. Used by every poller on the site
 * (space status, events, countdown, next-event preview) - previously each one
 * repeated the same `if (document.visibilityState === "hidden") return;` guard.
 */
export function setVisibleInterval(fn: () => void, ms: number): ReturnType<typeof setInterval> {
  return setInterval(() => {
    if (document.visibilityState === "hidden") return;
    fn();
  }, ms);
}
